<template>
  <div class="parent-box">
    <div class="nav">
      <StatusView />
      <div class="navbox">
          <img class="left" src="@/assets/nav/yz_nav_fh.png" alt="" v-on:click="goBack()"/>
      </div>
    </div>
    <img
      src="../../assets/invite/invite_banner.png"
      alt=""
      class="invite-banner"
    />
    <div class="invite-detail">
      <h3>
        已成功邀请
        <span v-for="(item, index) in state.countArr" :key="index">
          {{ item }}
        </span>
        位新好友
      </h3>
      <p>分享你的<span>专属邀请链接</span>给好友</p>
      <img
        src="../../assets/invite/invite_button.png"
        alt=""
        class="animate__animated animate__pulse"
        id="copy-btn"
        @click="copyShareUrl('#copy-btn')"
      />
    </div>
    <div class="award-info">
      <div>
        <img src="../../assets/invite/invite_award_info1.png" alt="" />
        每邀请一位好友并在App内实名
      </div>
      <p>你可立得<span>1元赠送余额</span></p>
      <div>
        <img
          src="../../assets/invite/invite_award_info2.png"
          alt=""
        />好友在部分游戏中的每笔现金充值
      </div>
      <p>你可获得<span>20%的赠送余额返利</span></p>
    </div>
    <div class="award-detail">
      <p>
        已赚取赏金「赠送余额」<img
          src="../../assets/invite/invite_award_icon.png"
          alt=""
        /><span>{{ state.withdrawal }}</span>
      </p>
      <p>赏金奖励自动发放</p>
    </div>
    <van-popup
      class-name="van-popup"
      v-model:show="state.showRuleDialog"
      round
      position="bottom"
      :style="{ background: ' rgba(0, 0, 0, 0)' }"
    >
      <div class="dialog-box">
        <img src="../../assets/invite/invite_rule_info.png" alt="" />
        <img
          src="../../assets/invite/invite_reule_close.png"
          alt=""
          class="close-btn"
          @click="state.showRuleDialog = false"
        />
      </div>
    </van-popup>
    <img
      src="../../assets/invite/invite_rule.png"
      alt=""
      class="invite-rule"
      @click="state.showRuleDialog = true"
    />
  </div>
</template>

<script setup>
import { reactive, ref, onActivated, onMounted, nextTick } from "vue";
import { revenueCenter } from "@/api/yzuser";
import { useRoute, useRouter } from "vue-router";
import { getQueryString } from "@/utils/location";
import { handleCopy } from "@/utils/tool";
import { detect } from "@/utils/device";
import StatusView from "@/views/public/StatusView.vue";
import "animate.css";
const active = ref(0);
const route = useRoute();
const router = useRouter();
const state = reactive({
  withdrawal: "0",
  count: 0,
  showRuleDialog: false,
  uid: "",
  show_copy: false,
  qrcodeData: "",
  money: 0,
  countArr: [],
});

onActivated(() => {
  var fromdata = {
    // uid: getQueryString("uid"),
    uid: getQueryString("uid"),
  };
  revenueCenter(fromdata).then((response) => {
    console.log(response.data.data);
    state.withdrawal = response.data.data.withdrawal;
    state.count = response.data.data.countinvite;
    // 将state.count分割成数组
    state.countArr = state.count.toString().split("");
    state.shareUrl = response.data.data.url;
    state.money = response.data.data.money;
    console.log(state.countArr);
  });
});

const goBack = () => {
  if (detect() == "android" || detect() == "harmony") {
    window.document.location = "goBack://";
  }else {
    router.back()
  }
};

onMounted(() => {
  state.uid = localStorage.getItem("uid");
});

// 复制链接按钮
const copyShareUrl = (id) => {
  if (detect() == "android" || detect() == "harmony") {
    window.document.location =
      "share://";
  } else {
    // var message =
    //   "share://" +
    //   "http://hz.3zhe.com/register.html?uid=" +
    //   getQueryString("uid");
    // window.webkit.messageHandlers.JsBridge.postMessage(message);
    handleCopy(id, "https://qudao.zhekoushenqi.com/yaoqing?uid=" +getQueryString("uid"));

    
  }
};
</script>
<style>
body {
  background: #29190D;
}
</style>
<style scoped>
:deep(.van-sticky) {
  padding-top: calc(32px + constant(safe-area-inset-top));
  /* 适配安全区域 iOS < 11.2 */
  padding-top: calc(32px + env(safe-area-inset-top));
  /* 适配安全区域 iOS >= 11.2 */
}

.nav {
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100%;
}
.navbox {
  position: relative;
  height: 90px;
  width: 100%;
}

.navbox .left {
  width: 70px;
  height: 70px;
  padding: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 22px;
}




.van-nav-bar {
  /* background: #f7f7f7; */
  background: rgba(139, 111, 255, 0);
  padding-top: 58px;
}
.left-nr {
  display: flex;
}
.left-nr img {
  width: 60px;
  height: 60px;
}
.right-nr {
  color: #12cec7;
}
.parent-box,
.invite-detail,
.award-info,
.award-detail {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.parent-box {
  min-height: 100vh;
  background: url(../../assets/invite/invite_bg.png) no-repeat center top;
  background-size: 100% auto;
  position: relative;
  box-sizing: border-box;
  background-color: #291a0d;
  padding: 116px 32px 100px;
}
.parent-box .invite-rule {
  position: absolute;
  left: 0;
  top: 222px;
  width: 58px;
  height: 150px;
}
.parent-box > img {
  width: 516px;
  height: 268px;
}
.invite-detail {
  margin-top: 18px;
  width: 100%;
  height: 380px;
  background: url(../../assets/invite/invite_bg_1.png);
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.invite-detail h3 {
  font-size: 40px;
  font-weight: 600;
  color: #654200;
}
.invite-detail h3 span {
  display: inline-flex;
  width: 60px;
  height: 60px;
  background-image: url(../../assets/invite/invite_num.png);
  background-size: 100% 100%;
  color: #fff;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
}
.invite-detail p {
  margin: 24px 0 16px 0;
  color: #7e683c;
}
.invite-detail p span {
  color: #cb4e00;
  font-weight: 600;
}
.invite-detail > img {
  width: 376px;
  height: 148px;
  animation-iteration-count: infinite;
}
/* 奖励说明 */
.award-info {
  margin-top: 26px;
  height: 550px;
  background: url(../../assets/invite/invite_bg_2.png);
  background-size: 100% 100%;
  padding-top: 166px;
}
.award-info div {
  color: #654200;
  font-size: 32px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.award-info div img {
  width: 54px;
  height: 54px;
  margin-right: 12px;
}
.award-info div:nth-of-type(2) {
  margin-top: 20px;
}
.award-info p {
  width: 528px;
  height: 72px;
  background-image: url(../../assets/invite/invite_award_bg.png);
  background-size: 100% 100%;
  text-align: center;
  line-height: 72px;
  font-weight: 900;
  font-size: 36px;
  color: #ffe9be;
  text-shadow: 0 0 4px #5c0000, 0 0 4px #5c0000, 0 0 4px #5c0000,
    0 0 4px #5c0000, 0 0 4px #5c0000, 0 0 4px #5c0000, 0 0 4px #5c0000;
}
.award-info p span {
  color: #ffe658;
}
/* 奖励详情 */
.award-detail {
  margin-top: 22px;
  height: 384px;
  background: url(../../assets/invite/invite_bg_3.png);
  background-size: 100% 100%;
  padding-top: 182px;
}
.award-detail p:nth-of-type(1) {
  font-size: 28px;
  color: #ffe9be;
  text-shadow: 0 0 4px #5c0000, 0 0 4px #5c0000, 0 0 4px #5c0000,
    0 0 4px #5c0000, 0 0 4px #5c0000, 0 0 4px #5c0000, 0 0 4px #5c0000;
  background-image: url(../../assets/invite/invite_awardDetail_bg.png);
  background-size: 100% 100%;
  width: 574px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
}
.award-detail p span {
  color: #ffe658;
}
.award-detail p:nth-of-type(2) {
  font-size: 24px;
  counter-reset: #726455;
  margin-top: 20px;
}

.award-detail p img {
  width: 44px;
  height: 44px;
  margin-right: 8px;
}

.dialog-box {
  background: rgba(139, 111, 255, 0);
  height: 1066px;
  width: 748px;
  overflow: hidden;
  position: relative;
}
.dialog-box img {
  width: 100%;
  height: 100%;
}
.dialog-box .close-btn {
  width: 62px;
  height: 62px;
  position: absolute;
  top: 38px;
  right: 42px;
}
</style>
